// extracted by mini-css-extract-plugin
export default {"root":"Select_root__Gqx23"};